import { Select, Stack } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { Screen } from './Screen';
import { getScreenList } from '../../../helpers/screen/backend_helper';
import CardWithError from '../../../Components/Common/CardWithError';
import {
	Col,
	Row,
	Card,
	CardHeader,
	CardBody,
	Alert,
	Spinner,
} from 'reactstrap';
import AddEditScreenModal from './Add_Edit/AddEditScreenModal';
import { ScreenLayoutConfig } from './ScreenLayoutConfig';

export const ScreensViewer = () => {
	const [screens, setScreens] = useState([]);
	const [error, setError] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const [screenSelected, setScreenSelected] = useState();
	const [modal, setModal] = useState(false);

	const handleToggleModal = () => {
		setModal(!modal);
	};

	useEffect(() => {
		setIsLoading(true);
		setError(null);

		getScreenList()
			.then(response => setScreens(response))
			.catch(error => setError(error))
			.finally(() => setIsLoading(false));
	}, []);

	if (error) {
		return <CardWithError />;
	}

	return (
		<React.Fragment>
			<Card>
				<CardHeader className='border-0 pb-0'>
					<div className='d-flex align-items-end justify-content-end'>
						<div className='flex-shrink-0'>
							<div className='d-flex flex-wrap gap-2'>
								<button
									className='btn btn-label btn-primary'
									onClick={() => {
										handleToggleModal();
									}}
								>
									<i className={`${Icons.plus} label-icon`}></i> Crear
									Screen
								</button>
							</div>
						</div>
					</div>
				</CardHeader>
				<CardBody>
					{isLoading && screens ? (
						<Alert color='primary'>
							<Spinner size='sm' className='me-2' />
							Cargando datos, por favor espere...
						</Alert>
					) : (
						<Stack>
							<Select
								label='Formulario'
								placeholder='Seleccione un formulario'
								value={screenSelected}
								onChange={setScreenSelected}
								data={
									screens?.map(screen => ({
										label: screen.name,
										value: screen._id,
									})) || []
								}
							/>
							{screenSelected && <Screen screenId={screenSelected} />}
						</Stack>
					)}
				</CardBody>
				{/* <ScreenLayoutConfig fields={screens[1]?.fields || []} /> */}
			</Card>

			<AddEditScreenModal
				dataScreen={[]}
				isEdit={false}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
			/>
		</React.Fragment>
	);
};
